
import Vue from 'vue';

export default Vue.extend({
  name: "BlockInternetPolicy",
  props: ["value", "lang"],

  data() {
    return {

    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  },
})
